export default (o, c, d) => {
  const proto = c.prototype;
  proto.toLocale = function (opts = {}) {
    const defaultOpts = {
      isZeroZoneTime: true,
      timeZone: 0,
      ...opts,
    };
    let inst = this;

    if (defaultOpts.isZeroZoneTime) {
      // dayjs初始化传入进来的时间为0时区的值，需要人为转为选择语言地区的时间
      /**
       * 东八区： 中国、马来西亚、菲律宾
       * 东七区： 越南、印度尼西亚、
       **/
      // 先将时间戳调整到0时区对应的时间对象
      const localDate = new Date();
      const offset = localDate.getTimezoneOffset() * 60 * 1000;
      inst = inst.add(offset);

      const locate = inst.$locale();
      if (!defaultOpts.timeZone) {
        if ("ms" === locate.name || "zh-cn" === locate.name || "en" === locate.name) {
          defaultOpts.timeZone = 8;
        } else if ("vi" === locate.name || "id" === locate.name) {
          defaultOpts.timeZone = 7;
        } else if ("de" === locate.name || "es" === locate.name) {
          defaultOpts.timeZone = 1;
        } else {
          defaultOpts.timeZone = 8;
        }
      }
      inst = inst.add(60 * 60 * 1000 * defaultOpts.timeZone);
    } else {
      // 时间为非0时区的时间，认定为本地时间，不处理，直接返回
    }
    return inst;
  };
};
